import React from "react";
import { useTranslation } from "react-i18next";

import TabComponent from "~/components/TabComponent";
import Wrapper from "~/shared/ui/Wrapper";
import { useGetLocationData, useGoToPreviousPage } from "~/hooks/locationData";

import DealerMetric from "./DealerMetric";

import styles from "./styles.less";
// import Agreements from "./Agreements";

const tabs = [
  {
    id: "dealerMetrics",
    label: "Справочник показателей для расчета нормативной численности ДЦ",
  },
  // { id: "agreements", label: "доп. Соглашения" },
];

const EditorDealerMetric = () => {
  const { t } = useTranslation();
  const goBack = useGoToPreviousPage();
  const { selected } = useGetLocationData();
  return (
    <Wrapper.Content
      title={"Справочник показателей"}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
    >
      <TabComponent
        tabs={tabs}
        horizontal="start"
        vertical="end"
        fontSize="16"
      />
      {selected === "dealerMetrics" && <DealerMetric />}
      {/*{selected === "agreements" && <Agreements />}*/}
    </Wrapper.Content>
  );
};

export default EditorDealerMetric;
